import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconBreadcrumbs from "../custom-breadcrumb";
import axios from 'axios';
import config from '../../config.json';

const RankingsPage = () => {
  const [state, setState] = useState({
    rankType: 'NONE',
    rankList: [],
    currentPage: 1,
    pageSize: 5,
  });

  const apiEndPoint = config.apiEndPoint + 'statistics/';
  const [searchParams, setSearchParams] = useSearchParams();
  const [rankType, setRankType] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const results = await axios.get(apiEndPoint + rankType);
      setState({
        rankType: rankType,
        rankList: results.data,
        currentPage: 1,
      });
    };
    if (rankType) fetchData();
  }, [rankType]);

  const handleChangePage = (page) => {
    setState({ currentPage: page });
  };

  const { rankList, currentPage, pageSize } = state;

  const navigateTo = (rankType) => {
    setRankType(rankType);
  };

  const title = () => {
    switch (rankType) {
      case 15:
      case 25:
      case 45:
      case 135:
      case 145:
        return 'Potency';
      case 2:
        return 'Money';
      case 3:
        return 'Virtue';
      case 4:
        return 'PK';
      case 5:
        return 'KO';
      case 6:
        return 'Guild';
      default:
        return 'Rank';
    }
  };

  const buttonStyles = {
    variant: "outlined",
    sx: {
      color: "#0d1b2a",
      borderColor: "#0d1b2a",
      fontWeight: 600,
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#0d1b2a",
        color: "#fff",
        borderColor: "#0d1b2a",
      },
    }
  };

  return (
    <Box sx={{ backgroundColor: "#f0f4f8", minHeight: "100vh", fontFamily: "'Poppins', sans-serif" }}>
      <IconBreadcrumbs name="Rankings" />
      <Container className="mt-5 mb-5 p-4 rounded-3" style={{ background: "#ffffff", boxShadow: "0 0 15px rgba(0,0,0,0.1)" }}>
        <Box display="flex" flexWrap="wrap" gap={2} mb={4}>
          <Button onClick={() => navigateTo(15)} {...buttonStyles}>Trojan</Button>
          <Button onClick={() => navigateTo(25)} {...buttonStyles}>Warrior</Button>
          <Button onClick={() => navigateTo(45)} {...buttonStyles}>Archer</Button>
          <Button onClick={() => navigateTo(135)} {...buttonStyles}>Water</Button>
          <Button onClick={() => navigateTo(145)} {...buttonStyles}>Fire</Button>
          <Button onClick={() => navigateTo(2)} {...buttonStyles}>Money</Button>
          <Button onClick={() => navigateTo(3)} {...buttonStyles}>Virtue</Button>
          <Button onClick={() => navigateTo(4)} {...buttonStyles}>PK</Button>
          <Button onClick={() => navigateTo(5)} {...buttonStyles}>KO</Button>
          <Button onClick={() => navigateTo(255)} {...buttonStyles}>Guilds</Button>
        </Box>

        <Row>
          <Col>
            {rankList.length === 0 && (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <h4 style={{ color: "#607d8b" }}>There are no ranks to show in this category.</h4>
              </Box>
            )}

            {rankList.length > 0 && (
              <Box sx={{ overflowX: "auto" }}>
                <table className="table table-hover" style={{ color: "#263238", minWidth: "600px" }}>
                  <thead className="table-light">
                    <tr style={{ fontWeight: "600", fontSize: "1rem" }}>
                      {rankType === 255 ? (
                        <>
                          <th>Name</th>
                          <th>Leader</th>
                          <th>Fund</th>
                          <th>Members</th>
                        </>
                      ) : (
                        <>
                          <th>Name</th>
                          <th>Level</th>
                          <th>{title()}</th>
                          <th>Guild</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {rankList.map((p, index) => (
                      <tr key={index}>
                        <td>{p.name}</td>
                        {rankType === 255 ? (
                          <>
                            <td>{p.leaderName}</td>
                            <td>{p.fund?.toLocaleString()}</td>
                            <td>{p.members}</td>
                          </>
                        ) : (
                          <>
                            <td>{p.level}</td>
                            <td>{p.param?.toLocaleString()}</td>
                            <td>{p.guildName}</td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            )}
          </Col>
        </Row>
      </Container>
    </Box>
  );
};

export default RankingsPage;
